import { getRegionId } from '../../packages/Filters/shared/utils/location';
import { IAppState } from '../common/state';

export const getCurrentRegionId = (state: IAppState): number => {
  return getRegionId(state.filters.currentLocation);
};
